export default __webpack_public_path__ + "static/media/nip_7.a88342e1.jpg";